import request from '@/utils/request'


// 查询结算付款列表
export function listSettlementPayment(query) {
  return request({
    url: '/user/settlement-payment/list',
    method: 'get',
    params: query
  })
}

// 查询结算付款分页
export function pageSettlementPayment(query) {
  return request({
    url: '/user/settlement-payment/page',
    method: 'get',
    params: query
  })
}

// 查询结算付款详细
export function getSettlementPayment(data) {
  return request({
    url: '/user/settlement-payment/detail',
    method: 'get',
    params: data
  })
}

// 新增结算付款
export function addSettlementPayment(data) {
  return request({
    url: '/user/settlement-payment/add',
    method: 'post',
    data: data
  })
}

// 修改结算付款
export function updateSettlementPayment(data) {
  return request({
    url: '/user/settlement-payment/edit',
    method: 'post',
    data: data
  })
}

// 删除结算付款
export function delSettlementPayment(data) {
  return request({
    url: '/user/settlement-payment/delete',
    method: 'post',
    data: data
  })
}
